export const blockIconsDeviceBatteryChargingFull = (
	<span className='material-symbols-outlined'>battery_charging_full</span>
);
